/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_Create_TitleInputs */

const en_settings_apikeys_create_title = /** @type {(inputs: Settings_Apikeys_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create API Key`)
};

const zh_settings_apikeys_create_title = /** @type {(inputs: Settings_Apikeys_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建 API 密钥`)
};

/**
* | output |
* | --- |
* | "Create API Key" |
*
* @param {Settings_Apikeys_Create_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_create_title = /** @type {((inputs?: Settings_Apikeys_Create_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_Create_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_apikeys_create_title(inputs)
	return zh_settings_apikeys_create_title(inputs)
});
export { settings_apikeys_create_title as "settings.apikeys.create_title" }